export default new class MobileMenu {
    constructor() {
        this.mMenuOpenBtnSelector = '_mmenu-btn-open';
        this.mMenuCloseBtnSelector = '_mmenu-btn-close';
        this.mMenuWrapperSelector = '_mmenu-wrapper';
        this.handler();
    }

    handler() {
        $(document).on('click', `.${this.mMenuOpenBtnSelector}`, () => {
            const wrapper = $(`.${this.mMenuWrapperSelector}`);
            wrapper.toggleClass('hidden');
        });
        $(document).on('click', `.${this.mMenuCloseBtnSelector}`, () => {
            const wrapper = $(`.${this.mMenuWrapperSelector}`);
            wrapper.toggleClass('hidden');
        });
    }
}();
